import styled, { css } from 'styled-components'

import { BRAND } from 'constants/appConstants'
import { theme } from 'utils/theme'

export const MasterContainer = styled.div`
  display: grid;
  grid-template-columns: calc(100% - 295px) 255px;
  grid-gap: 40px;
  height: 100%;
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;
  justify-content: space-between;
  margin-bottom: 20px;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SubSectionContainer = styled.div``

export const SectionTitle = styled.h2`
  font-size: 28px;
  line-height: 32px;

  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          font-family: AzoSans;
          font-weight: 600;
          color: ${theme.colors.lightGold};
          margin-bottom: 24px;
        `
      : css`
          font-family: 'Futura Std';
          font-weight: 700;
          color: ${theme.colors.white};
          margin-bottom: 20px;
        `}
`

export const MoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const ContentTypesContainer = styled.div``

export const ContentTypesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  .btn {
    width: 100%;
  }
`

export const FullScheduleContainer = styled.div`
  padding: 26px 0 0;
`
